
import Vue, { PropOptions } from "vue";
import ChildAvatarEditable from "~/components/page-components/ChildAvatarEditable.vue";
import ChildDescription from "~/components/page-components/ChildDescription.vue";
import { commonService } from "~/lib/accessors/api";
import ChildView from "~/lib/types/ChildView";
import PhotoGallery from '~/components/misc/PhotoGallery.vue'
import { globalStore, transactionsStore } from "~/lib/accessors/store-accessor";
import { CHANGE_CHILD } from "~/lib/constants";

export default Vue.extend({
  components: { ChildDescription, ChildAvatarEditable, PhotoGallery },
  props: {
    child: {
      type: Object,
      required: true,
    } as PropOptions<ChildView>,
    showHelpButton: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    publicView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infoPopupVisible: false,
      infoPopupText: "",
    };
  },
  computed: {
    is_dummy() {
      return this.$user().role === 'dummy';
    },
    transactionsAggregate() {
      return transactionsStore.transactionsAggregate;
    },
    isZmieniamPodopiecznego(): boolean {
      return CHANGE_CHILD in this.$route.query;
    },
    alreadyHelpingThisChild(): boolean {
      return this.$user().child.id === this.child.id;
    },
  },
  methods: {
    async impersonate() {
      await commonService.withContext(this).impersonateUser(this.child.id + "");

      // reload page
      window.location.href = window.location.href;
    },
    async stop_impersonation() {
      await commonService.withContext(this).stopImpersonation();
    },
    openVodal(text: string) {
      globalStore.openVodal(text);
    },
    async changeChild() {
      // Button is disabled and this is just in case
      if(this.alreadyHelpingThisChild) {
        return;
      }

      // KIPR-11: Helper user changes child that he wants to support
      if(confirm(`Czy na pewno chcesz zmienić podopiecznego na ${this.child.fullName}?`)) {
        await commonService.withContext(this).changeChild({
          oldChildId: this.$user().child.id,
          newChildId: this.child.id,
        });

        // We do full page reload so `$auth` is reloaded, because current child that the user
        // is helping is stored in `$user` (`AuthUser`).
        window.location.href = this.$router.resolve({name: 'zalogowany-pomagajacy'}).href;
      }
    }
  },
});
